import React from "react";
import { useTranslation } from "react-i18next";
import { EmptyPlaceHolder } from "../widgets";

interface IProps {}

const AppAccessDenied = (props: IProps) => {
    const { t } = useTranslation();

    return (
        <EmptyPlaceHolder
            headerName={t("Shared.NoAppPermission")}
            headerDescription={t("Shared.NoAppPermissionDescription")}
            hideButton
        />
    );
};

export default AppAccessDenied;
